import styled from '@emotion/styled'
import type React from 'react'
import Colors from '../../figma/panda/Colors'
import BorderRadius from '../../figma/tokens/BorderRadius'
import Spacings from '../../figma/tokens/Spacings'
import FigmaBox from './FigmaBox'

type Props = {
  children: React.ReactNode
}

const ModalExperimentalFooter: React.FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ children }) => (
  <Wrapper fullWidth>{children}</Wrapper>
)

const Wrapper = styled(FigmaBox)`
  padding: ${Spacings.tiny} ${Spacings.medium};
  background: ${Colors.backgroundColorsBackground};
  border-radius: 0 0 ${BorderRadius.soft} ${BorderRadius.soft};
  border-top: 1px solid ${Colors.base300};
`

export default ModalExperimentalFooter
